/**
 * ProHabbo
 *
 * Henrique Arthur <eu@henriquearthur.com.br>
 */

 Channel = {
    addView: function() {
        var a = $(this);
        var id = a.data('id');

        $.post('/a/viewChannel/video/addView', {'id': id}, function(data) {
            if (data.status == 'success') {
                var number = a.parent().find('.num-views');
                var newNumber = parseInt(number.text()) + 1;

                number.text(newNumber);
            }
        });
    },
    changeAvatar: {
        choose: function() {
            var input = this;

            if (input.files && input.files[0]) {
                var reader = new FileReader();

                reader.onload = function(e) {
                    $("#channel-profile-avatar-preview").css('background-image', 'url('+e.target.result+')');

                    var id = $("#channel-profile-avatar-input").data('id');
                    var file = reader.result;

                    $(".channel-profile-avatar-form").submit();
                };

                reader.readAsDataURL(input.files[0]);
            }
        },
        send: function(e) {
            e.preventDefault();

            var formData = new FormData(this);

            $.ajax({
                url: '/a/viewChannel/updateAvatar',
                type: 'post',
                dataType: 'json',
                cache: false,
                contentType: false,
                processData: false,
                data: formData,
            }).done(function(data) {
            });
        }
    },
    edit: {
        show: function() {
            var html = '';

            var title       = $.trim($(".channel-title").text());
            var description = $.trim($(".channel-description").text());

            html += '<form class="form-channel-edit">';

            html += '<div class="form-group">';
            html += '<label>Nome</label>';
            html += '<input type="text" class="form-control" name="title" placeholder="Digite o nome do canal" value="'+title+'">';
            html += '</div>';

            html += '<div class="form-group">';
            html += '<label>Descrição</label>';
            html += '<textarea class="form-control" name="description" placeholder="Digite a descrição do canal">'+description+'</textarea>';
            html += '</div>';

            html += '<center><button type="submit" class="btn btn-primary btn-warning">Enviar</button></center>';
            html += '</form>';

            Alertbox({
                title: "Editar canal",
                content: html,
                type: 'misc'
            });
        },
        send: function(e) {
            e.preventDefault();

            var form = $(this);

            if (form.hasClass('disabled')) {
                return false;
            }

            var title       = form.find('input[name="title"]').val();
            var description = form.find('textarea[name="description"]').val();

            if (title == '' || description == '') {
                form.effect('shake', { distance: 3 });
            } else {
                form.addClass('disabled').animate({'opacity': 0.5});

                $.ajax({
                    url: '/a/viewChannel/edit',
                    type: 'POST',
                    dataType: 'json',
                    data: {'title': title, 'description': description},
                }).done(function(data) {
                    form.removeClass('disabled').animate({'opacity': 1});

                    if (data.status == 'error') {
                        var message = "";

                        for (i = data.messages.length - 1; i >= 0; i--) {
                            message += data.messages[i];

                            if (i > 0) {
                                message += '<br>';
                            }
                        }

                        Alertbox({
                            title: "Erro ao editar canal",
                            content: message,
                            type: 'error'
                        });
                    } else {
                        $.fancybox.close();

                        $(".channel-title").text(title);
                        $(".channel-description").text(description);
                    }
                });
            }
        }
    },
    addVideo: function(e) {
        e.preventDefault();

        var form = $(this);

        if (form.hasClass('disabled')) {
            return false;
        }

        var title = form.find('input[name="title"]').val();
        var link  = form.find('input[name="youtube_link"]').val();

        if (title == '' || link == '') {
            form.effect('shake', { distance: 3 });
        } else {
            form.addClass('disabled').animate({'opacity': 0.5});

            $.ajax({
                url: '/a/viewChannel/video/add',
                type: 'POST',
                dataType: 'json',
                data: {'title': title, 'link': link},
            }).done(function(data) {
                form.removeClass('disabled').animate({'opacity': 1});

                if (data.status == 'error') {
                    var message = "";

                    for (i = data.messages.length - 1; i >= 0; i--) {
                        message += data.messages[i];

                        if (i > 0) {
                            message += '<br>';
                        }
                    }

                    Alertbox({
                        title: "Erro ao enviar vídeo",
                        content: message,
                        type: 'error'
                    });
                } else {
                    $.fancybox.close();

                    Alertbox({
                        title: 'Enviado com sucesso!',
                        content: "Seu vídeo foi enviado com sucesso. Após revisão da nossa moderação, seu vídeo estará disponível no seu canal e visível para todos no site da ProHabbo.",
                        type: 'success'
                    });

                    form.find('input[name="title"]').val('');
                    form.find('input[name="youtube_link"]').val('');
                }
            });
        }
    },
    subscribe: function() {
        var button = $(this);

        if (button.hasClass('disabled')) {
            return false;
        }

        var id   = button.data('id');

        if (id > 0) {
            button.addClass('disabled');

            $.ajax({
                url: '/a/viewChannel/subscribe',
                type: 'POST',
                dataType: 'json',
                data: {
                    'id': id
                },
            }).done(function(data) {
                button.removeClass('disabled');

                if (data.status == "error") {
                    var message = "";

                    for (i = data.messages.length - 1; i >= 0; i--) {
                        message += data.messages[i];

                        if (i > 0) {
                            message += '<br>';
                        }
                    }

                    Alertbox({
                        title: "Erro ao inscrever",
                        content: message,
                        type: 'error'
                    });
                } else if (data.status == "success") {
                    if (data.action == 'insert') {
                        $(".channel-subscribe").addClass('active').text('Inscrito!');
                    } else if (data.action == 'remove') {
                        $(".channel-subscribe").removeClass('active').text('Inscrever-se');
                    }
                }
            });
        }
    },
    init: function() {
        $("#channel-profile-avatar-input").on('change', Channel.changeAvatar.choose);
        $(".channel-profile-avatar-form").on('submit', Channel.changeAvatar.send);

        $(".channel-edit-button").on('click', Channel.edit.show);
        $(document).on('submit', ".form-channel-edit", Channel.edit.send);

        $(".channel-add-video-form").on('submit', Channel.addVideo);

        $(".channel-subscribe").on('click', Channel.subscribe);

        $(".paginate-channel-subscribed").paginate({
            onChangePage: function() {
                Main.plugins.tooltip();
            }
        });

        $(".paginate-channel-subscription").paginate({
            onChangePage: function() {
                Main.plugins.tooltip();
            }
        });

        $('[data-fancybox="channel-video"]').on('click', Channel.addView);
    }
};

